import { Schema } from "prosemirror-model";

/**
 * Custom ProseMirror schema for NLS documents.
 *
 * Structure: doc > statement+ > inline*
 * Each statement has attrs: sid, level, collapsed
 * Text can have nls_link marks for hyperlinks.
 */
export const nlsSchema = new Schema({
  nodes: {
    doc: {
      content: "statement+",
    },

    statement: {
      content: "inline*",
      group: "block",
      attrs: {
        sid: { default: "" },
        level: { default: 0 },
        collapsed: { default: false },
      },
      parseDOM: [
        {
          tag: "div.nls-statement",
          getAttrs(dom: HTMLElement) {
            return {
              sid: dom.getAttribute("data-sid") ?? "",
              level: parseInt(dom.getAttribute("data-level") ?? "0", 10),
              collapsed: dom.getAttribute("data-collapsed") === "true",
            };
          },
        },
      ],
      toDOM(node) {
        return [
          "div",
          {
            class: `nls-statement level-${node.attrs.level as number}`,
            "data-sid": node.attrs.sid as string,
            "data-level": String(node.attrs.level),
            "data-collapsed": String(node.attrs.collapsed),
          },
          0,
        ];
      },
    },

    text: {
      group: "inline",
    },
  },

  marks: {
    nls_link: {
      attrs: {
        documentId: { default: null },
        sid: { default: null },
        viewspec: { default: null },
      },
      inclusive: false,
      parseDOM: [
        {
          tag: "a.nls-link",
          getAttrs(dom: HTMLElement) {
            return {
              documentId: dom.getAttribute("data-doc"),
              sid: dom.getAttribute("data-sid"),
              viewspec: dom.getAttribute("data-viewspec"),
            };
          },
        },
      ],
      toDOM(mark) {
        return [
          "a",
          {
            class: "nls-link",
            "data-doc": mark.attrs.documentId as string,
            "data-sid": mark.attrs.sid as string,
            "data-viewspec": mark.attrs.viewspec as string,
            title: `→ ${mark.attrs.documentId as string}${mark.attrs.sid ? ":" + (mark.attrs.sid as string) : ""}`,
          },
          0,
        ];
      },
    },
  },
});
